const API_KEY = "2e0bfe56b018618b270a6e0428559292";
const BASE_URL = "https://api.themoviedb.org/3";

export default async function get(url: string, options?: any) {
  const res = await fetch(
    BASE_URL + url + `?api_key=${API_KEY}`,
    options ? options : {}
  );
  return await res.json();
}
